module.exports = __webpack_public_path__ + "img/freespin3_multiplier12.98143956.png";